import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import rolebleMixin from '@/mixins/rolebleMixin'
import ChatParticipant from '@/models-ts/chat/ChatParticipant'
import ChatRoom from '@/models-ts/chat/ChatRoom'
import { getHumanDate } from '@/utils/date'

export default Vue.extend<any, any, any, any>({
  mixins: [rolebleMixin],
  props: {
    room: ChatRoom,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userIsLoaded: (state: any) => state.user.profile.isLoaded,
      userId: (state: any) => state.user?.id,
    }),
    ...mapGetters({
      getUnreadCount: 'chatNew/getUnreadCount',
    }),
    participant() {
      return this.room.participants.find((user: ChatParticipant) => user.userId !== String(this.userId))
    },
    date() {
      return getHumanDate(this.room.lastMessageAt)
    },
    unreadCount() {
      const unreadCount = this.getUnreadCount(this.room.id)
      return unreadCount > 99 ? '99+' : unreadCount
    },
  },
  methods: {
    onSelfClick() {
      this.$router.push(this.room.chatLink)
    },
  },
})
